/* eslint-disable no-restricted-globals */
import {
  AndroidFilled,
  AppleFilled,
  QrcodeOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, message, Select } from 'antd';
import queryString from 'query-string';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import Logo from '../../../assets/images/logo_login.png';
import DashLogo from '../../../assets/images/dash_logo.png';
import HoasenLogo from '../../../assets/images/hoasen_logo_login.png';
import HoasenHomeLogo from '../../../assets/images/hoasen_home_Logo_2.png';
import * as SERVICE from '../../../constants/service.types';

import * as SYSTEM from '../../../constants/system.keys';
import {
  APP_ID,
  GOOGLE_CLIENT_ID,
  GOOGLE_NAMESPACE,
  GOOGLE_USERNAME,
} from '../../../constants/system.keys';
import {
  authLogoutThunk,
  changeLocales,
  getPublicIpReturn,
  openMessage,
  socketEmitEvent,
  updateNamespace,
} from '../../../redux/actions';
import './index.scss';

import Axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { resetDataToken } from '../../../redux/socket';
import LoginByAccessTokenComponent from './LoginByAccessToken';
import {
  default as LoginByPhoneNumberComponent,
  default as UserName,
} from './UsernameV2';
import { LoginByPasskey } from './LoginByPasskey';
import { FingerprintIcon } from '../../../icons/Fingerprint';
import { beeXLogger } from '../../../helpers/logger';

const { Option } = Select;
const HOSTNAME = window.location.hostname;
const LOGO = {
  'cloudcam.dashhome.vn': DashLogo,
  'cloudcam.hoasenhome.vn': HoasenHomeLogo,
  'cloudcam1.hoasengroup.vn': HoasenLogo,
};

const BACKGROUND_LOGO_CLASS = {
  'cloudcam.dashhome.vn': 'logo dash-logo',
  'cloudcam.hoasenhome.vn': 'logo hoasen-logo',
  'cloudcam1.hoasengroup.vn': 'logo hoasen-logo',
};
const LOGIN_CONTAINER_CLASS = {
  'cloudcam1.hoasengroup.vn': 'login-component hoasen-login-component',
  'cloudcam.hoasenhome.vn': 'login-component hoasen-login-component',
};

const LOGIN_FORM_CLASS = {
  'cloudcam1.hoasengroup.vn': 'login-form hoasen-login-form',
  'cloudcam.hoasenhome.vn': 'login-form hoasen-login-form',
};

const LOGIN_FORM_CONTENT_CLASS = {
  'cloudcam1.hoasengroup.vn': 'left-login-component hoasen-login-form',
  'cloudcam.hoasenhome.vn': 'left-login-component hoasen-login-form',
};

const NAMESPACE_CLASS = {
  'cloudcam1.hoasengroup.vn': 'hoasen-namespace',
  'cloudcam.hoasenhome.vn': 'hoasen-namespace',
};

const BANNER_LOGIN = {
  'cloudcam1.hoasengroup.vn': <div className="hoasen-login-banner"></div>,
  'cloudcam.hoasenhome.vn': <div className="hoasen-login-banner"></div>,
};

const LoginPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const [namespaces, setNamespaces] = useState();
  const refTimer = useRef();
  const [connectServerTimer, setConnectServerTimer] = useState(0);
  const [selectNamespace, setSelectNamespace] = useState();
  const [loginMessageReturn, setLoginMessageReturn] = useState();
  const [checkResult, setCheckResult] = useState(false);
  const [typeTab, setTypeTab] = useState(0);
  const [key, setKey] = useState(Math.random());

  console.log('Enter login page =======> ', location.state);
  const getLogoIcon = useMemo(() => {
    return LOGO[HOSTNAME] || Logo;
  }, []);

  useEffect(() => {
    localStorage.removeItem('force_change_namespace');
    return () => {
      localStorage.removeItem('force_change_namespace');
    };
  }, []);

  const verifyLoginByGoogle = useCallback(
    ({ code, googleClientId, googleNamespace, googleUsername }) => {
      let dataBody = {
        appId: APP_ID,
        clientId: googleClientId,
        username: googleUsername,
        idTokenClaims: code,
        namespace: googleNamespace,
        language: localStorage.getItem('language') ?? 'vi',
      };
      let dataObj = {
        appServiceType: SERVICE.AUTHENTICATION_GOOGLE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(updateNamespace(googleNamespace));
      dispatch(socketEmitEvent(dataObj));
    },
    [dispatch],
  );

  useEffect(() => {
    if (location.state && location.state?.query) {
      const { code } = queryString.parse(location.state.query);
      const googleClientId = localStorage.getItem(GOOGLE_CLIENT_ID);
      const googleNamespace = localStorage.getItem(GOOGLE_NAMESPACE);
      const googleUsername = localStorage.getItem(GOOGLE_USERNAME);

      if (code && googleClientId && googleNamespace && googleUsername) {
        console.log('Login with google =========> ');
        verifyLoginByGoogle({
          code,
          googleClientId,
          googleNamespace,
          googleUsername,
        });
      }
    }
  }, [location.state, verifyLoginByGoogle]);

  const {
    isAuth,
    namespaces: listNamespaces,
    invalidAuthData,
    socketState,
  } = useSelector((state) => state);

  useEffect(() => {
    if (socketState !== 1) {
      refTimer.current = setInterval(() => {
        setConnectServerTimer((timer) => timer + 1);
      }, 1000);
    }
    return () => {
      clearInterval(refTimer.current);
      setConnectServerTimer(0);
    };
  }, [socketState]);

  useEffect(() => {
    if (connectServerTimer >= 5) {
      clearInterval(refTimer.current);
      setConnectServerTimer(0);
      message.warning('Trying to connect to server...', 5);
    }
  }, [connectServerTimer, dispatch]);

  const [tempType, setTempType] = useState(1);
  const [type, setType] = useState(
    /**
     * @type 0: default, 1: phonenumber, 2:accessToken, 3 select namespace
     */
    0,
  );
  useEffect(() => {
    if (invalidAuthData) {
      setLoginMessageReturn(invalidAuthData);
    }
    return () => {
      setLoginMessageReturn(null);
    };
  }, [invalidAuthData]);

  useEffect(() => {
    // ACCESS_TOKEN_EXPIRED = -1;
    // ACCOUNTKIT_TOKEN_LOGIN_ERROR = -5;
    // INVALID_ACTIVATION_CODE = -6;
    // DO_NOT_PERMISSION_ERROR = -7;
    // USER IS BLOCKED = -15

    console.log('🚀 ~ LoginPage ~ loginMessageReturn:', loginMessageReturn);
    if (loginMessageReturn) {
      const { result } = loginMessageReturn;
      if (result === -7 && !checkResult) {
        setCheckResult(true);
        openMessage(
          SYSTEM.NOTIFIES.ERROR,
          t('You are not authorized to login'),
        );
      } else if (result !== -7) {
        openMessage(
          SYSTEM.NOTIFIES.ERROR,
          result === -1
            ? t('Access token expired')
            : result === -5
              ? t('Account kit token error login')
              : result === -6
                ? t('Invalid activation code')
                : result === -15
                  ? t(
                      'Your account has been temporarily suspended due to a policy violation. Please contact the admin to have it reinstated.',
                    )
                  : t('You are not authorized to login'),
        );
      }
    }
  }, [checkResult, dispatch, loginMessageReturn, t]);

  useEffect(() => {
    async function getPublicIp(cb) {
      try {
        let result = await Axios.get(SYSTEM.CHECK_IP_URL);
        if (result.status === 200) {
          return cb(result.data);
        }
        return cb(null);
      } catch (error) {
        return false;
      }
    }
    getPublicIp((publicIp) => {
      return dispatch(getPublicIpReturn(publicIp));
    });
  }, [dispatch]);

  useEffect(() => {
    let localLanguage = localStorage.getItem(SYSTEM.LANGUAGE);
    if (!localLanguage || localLanguage.length === 0) {
      localLanguage = 'en';
    }
    dispatch(changeLocales(localLanguage));
  }, [dispatch]);

  useEffect(() => {
    if (isAuth === 1) {
      beeXLogger.log('LIST_NAMESPACE_BY_ACCOUNT request');
      let data = {};
      let dataObj = {
        appServiceType: SERVICE.LIST_NAMESPACE_BY_ACCOUNT,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
    return () => {};
  }, [dispatch, isAuth]);

  useEffect(() => {
    if (listNamespaces) {
      if (listNamespaces.length > 1) {
        setType(3);
        setNamespaces(listNamespaces);
      } else {
        dispatch(updateNamespace(listNamespaces[0]));
      }
    }
    return () => {
      setType(0);
      setNamespaces(null);
    };
  }, [dispatch, listNamespaces]);

  const handleSelectNamespace = () => {
    if (selectNamespace) {
      return dispatch(updateNamespace(selectNamespace));
    }
  };

  const handleGooglePlay = () => {
    window.open('https://play.google.com/store/apps/details?id=com.beex');
  };

  const handleAppStore = () => {
    window.open('https://apps.apple.com/us/app/cloudcam/id1510319845');
  };

  return (
    <div className={LOGIN_CONTAINER_CLASS[HOSTNAME] || 'login-component'}>
      <div className="login-container">
        <div className={LOGIN_FORM_CLASS[HOSTNAME] || 'login-form'}>
          <div
            className={
              LOGIN_FORM_CONTENT_CLASS[HOSTNAME] || 'left-login-component'
            }
          >
            <div className="logo-login-component">
              <div className={BACKGROUND_LOGO_CLASS[HOSTNAME] || 'logo'}>
                <img alt="webee-logo" src={getLogoIcon} />
              </div>
            </div>
            <div className="select-type-login">
              {typeTab === 0 ? (
                <div key={key} className="main-login-component">
                  {type === 0 ? (
                    <div className="first-step-login-component">
                      <div className="select-type">
                        <Button
                          onClick={() => setTempType(1)}
                          size="large"
                          type={tempType === 1 && 'primary'}
                          icon={<UserOutlined />}
                        >
                          {t('Account')}
                        </Button>
                        <Button
                          onClick={() => setTempType(2)}
                          size="large"
                          type={tempType === 2 && 'primary'}
                          icon={<QrcodeOutlined />}
                        >
                          {t('Access Token')}
                        </Button>
                        {/* <Button
                          onClick={() => setTempType(4)}
                          size="large"
                          type={tempType === 4 && 'primary'}
                          className="passkey-button"
                          icon={<FingerprintIcon width={16} height={16} />}
                        >
                          {t('Passkey')}
                        </Button> */}
                      </div>
                      <div className="button-continue">
                        <Button
                          onClick={() => setType(tempType)}
                          shape="round"
                          size="large"
                          type="primary"
                        >
                          {t('Continue')}
                        </Button>
                      </div>
                    </div>
                  ) : type === 1 ? (
                    <LoginByPhoneNumberComponent onBack={() => setType(0)} />
                  ) : type === 2 ? (
                    <LoginByAccessTokenComponent onBack={() => setType(0)} />
                  ) : type === 4 ? (
                    <LoginByPasskey onBack={() => setType(0)} />
                  ) : (
                    <div className="_3th-step-login-component">
                      <div className="select-namespaces">
                        <div />
                        <Select
                          className={NAMESPACE_CLASS[HOSTNAME] || ''}
                          loading={!namespaces}
                          onSelect={(value) => setSelectNamespace(value)}
                          size="large"
                          placeholder={t('Select namespace')}
                        >
                          {namespaces &&
                            namespaces.map((namespace, index) => (
                              <Option key={index} value={namespace}>
                                {namespace}
                              </Option>
                            ))}
                        </Select>
                        <div />
                      </div>
                      <div className="confirm-btn">
                        <Button
                          shape="round"
                          onClick={() => {
                            resetDataToken();
                            dispatch(authLogoutThunk());
                            setType(0);
                          }}
                        >
                          {t('Back')}
                        </Button>
                        <Button
                          shape="round"
                          type="primary"
                          disabled={!selectNamespace}
                          onClick={() => handleSelectNamespace()}
                        >
                          {t('Continue')}
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div key={key} className="main-login-component">
                  <UserName onBack={() => setType(0)} />
                </div>
              )}
            </div>
            <div className="download-component">
              <div className="title">Download</div>
              <div className="download-btn">
                <Button
                  icon={<AndroidFilled />}
                  onClick={() => handleGooglePlay()}
                >
                  Google Play
                </Button>
                <Button icon={<AppleFilled />} onClick={() => handleAppStore()}>
                  App Store
                </Button>
              </div>
            </div>
          </div>
        </div>
        {BANNER_LOGIN[HOSTNAME] || ''}
      </div>
    </div>
  );
};

export default LoginPage;
